/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./SidebarProfileDropdownBody.vue?vue&type=template&id=b4d1aa6a&scoped=true"
import script from "./SidebarProfileDropdownBody.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarProfileDropdownBody.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SidebarProfileDropdownBody.vue?vue&type=style&index=0&id=b4d1aa6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d1aa6a",
  null
  
)

export default component.exports